import { ProductsModal } from '@app/components/Modals';
import {
  useAddProductsModal,
  useAddProductsModalEffects,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/hooks';
import type { AddProductsModalType } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/types';

export const AddProductsModal: AddProductsModalType = (props) => {
  const {
    checkedKeys,
    onSelect,
    onCheck,
    isOpen,
    treeData,
    searchValue,
    onSearch,
    skipFilters,
    addProducts,
    onCancel,
    checkedKeysHandler,
  } = useAddProductsModal(props);

  useAddProductsModalEffects({ checkedKeysHandler });

  return (
    <ProductsModal
      isOpen={isOpen}
      onCancel={onCancel}
      onOk={addProducts}
      searchValue={searchValue}
      onSearch={onSearch}
      treeData={treeData}
      checkedKeys={checkedKeys}
      onSelect={onSelect}
      onCheck={onCheck}
      skipFilters={skipFilters}
    />
  );
};
